<template>
    <div
      id="app"
      :class="[Util.testEnv() && isFrame ? 'app' : 'iframe_st', isForbidding ? 'forbidding' : '']"
      :style="{ backgroundImage: Util.testEnv() && isFrame ? `url(${bgImg})` : '' }"
      v-if="isShowPage"
    >
      <div
        :class="Util.testEnv() ? (mcGameShow ? screenClass1 : screenClass) : ''"
        :style="frameData"
        v-if="Util.testEnv() && isFrame"
      >
        <div id="iner_ct" :class="{ iner_ct: Util.testEnv() && isFrame }">
          <iframe scrolling="no" class="pc_ifra" :src="href"></iframe>
        </div>

        <!-- <a href="javascript:;" class="rotation_btn" @click="methods.triggerRotation"></a> -->
      </div>

      <template v-else>
        <router-view v-slot="{ Component }">
          <keep-alive :include="keepAliveCom" :max="20">
            <component :is="Component" :key="route.fullPath"></component>
          </keep-alive>
        </router-view>
      </template>
    </div>
  </template>

  <script lang="js">

  import { defineComponent, onMounted, onBeforeMount, reactive, watch, toRefs, getCurrentInstance, computed } from 'vue';
  import util from '@/assets/js/lib/util';
  import router from "@/router";
  import { useRoute  } from "vue-router";
  import { Dialog  } from "vant";
  import logo from "@/assets/images/common/white_logo.png"
  import store from '@/store';
  export default defineComponent({
    name: 'App',
    components: {Dialog},
    setup(props, context) {
      const state = reactive({
          Util: new util(),
          bgImg:'',
          route: useRoute(),
          winnerW:1,
          screen: true,//true竖屏，false横屏
          screenClass: "inner_box", //inner_box_landscape
          screenClass1: "inner_box change_box_client",
          mcGameShow: true, //默认不是微端
          href: '',
          isFrame: window.self === window.top,
          keepAliveCom: ['Index', 'ForumDetail', 'Game', 'Find', 'Welfare', 'Message', 'MineDetail','MineGame','ReplyNews','LikesNews','InviteNews', 'searchPage', 'strategy', 'superTopic'], //缓存组件的组件name值
          frameData: {
              width: 0,
              height: 0
          },
          isForbidding: window.Config.isAndroid || window.Config.isSdk, //是否安卓环境，安卓环境禁止长按事件发生
          closeAppTime: 0, //在主页面 500 毫秒内两次按返回，关闭app,只在壳包中使用
          isShowPage: true,
      });
      const route = useRoute()
      const { ctx } = getCurrentInstance();
      let flag = false;
      let load = false
      const initRemSize = () => {
          const designWidth = 750;
          const rem2px = 200;

          // const rem2px = 1400; //这个比例是跟页面 1:1 的，等同于 10 ： 1，font-size: 100px; (2021/10/18)

          setFontSize(designWidth, rem2px);
          //   setTimeout(()=> {
          //   setFontSize(designWidth, rem2px);
          //   }, 100);
          // 当屏幕宽度改变时，调用 setFontSize() 方法
          window.onresize = () => {

              if(!state.Util.testEnv()) return

              if(flag){

                  if(load)return
                  load = true

                  setTimeout(() => {
                      flag = false
                      load = false
                  }, 10);
              }else{
                  flag = true;
                  setFontSize(document.documentElement.clientWidth, rem2px);
              }

          };
      };

      const setFontSize = (designWidth, rem2px) => {

        // 获取当前设备的默认字体大小
          let defaultFontSize = 0;
          const div = document.createElement('div');
          const head = document.getElementsByTagName('head')[0];

          head.appendChild(div);
          div.style.width = '1rem';
          div.style.display = 'none';
          defaultFontSize = parseFloat(window.getComputedStyle(div, null).getPropertyValue('width'));

        // 计算等比缩放后 html 的 font-size
        // document.documentElement.style.fontSize = window.innerWidth / designWidth * rem2px / defaultFontSize * 100 + '%';
        // 横屏解决方案

          let wW =  window.innerWidth;
          let wH =  window.innerHeight

          if(state.Util.testEnv()){
              let bili = rem2px * wW / 357000.415 * 100;
              let frameData = state.frameData;
              //这里是运算PC端预览的单位

              //518/1040 * wH，是以高度为比例，算出来宽度
              // 这里是运算PC端预览的单位
              if(state.screen == false){//横屏
                  state.screenClass = "inner_box_landscape change_box_client";
                  frameData.width = `${wW - (430 / 1040 * wW)}px`;
                  frameData.height = `${518 / 1040 * wW - (220 / 518 * (518 / 1040 * wW))}px`;
                  frameData.paddingTop = `${24 / 1040 * wW}px`;
                  frameData.paddingBottom = `${24 / 1040 * wW}px`;
                  frameData.paddingLeft = `${33 / 518 * (518 / 1040 * wW)}px`;
                  frameData.paddingRight = `${33 / 518 * (518 / 1040 * wW)}px`;
                  frameData.height ='99%'
                  frameData.width = '99.8%'
              }else{//竖屏
                  state.screenClass = "inner_box change_box_client";
                  frameData.width = `${518 / 1040 * wH - (66 / 518 * (518 / 1040 * wH))}px`;
                  frameData.height = `${wH - (149 / 1040 * wH)}px`;
                  frameData.paddingTop = `${120 / 1040 * wH}px`;
                  frameData.paddingBottom = `${24 / 1040 * wH}px`;
                  frameData.paddingLeft = `${33 / 518 * (518 / 1040 * wH)}px`;
                  frameData.paddingRight = `${33 / 518 * (518 / 1040 * wH)}px`;
                  // frameData['min-width'] = `${414}px`;
                  frameData['max-width'] = `${375}px`;
              }
              frameData.paddingTop = 0
              frameData.transform='none';
              frameData.height ='99%'
              state.frameData = frameData;
              //这里是运算PC端预览的单位
              document.documentElement.style.fontSize = `625%`;
          }else{
              let rate = 100;
              document.documentElement.style.fontSize = `${wW / designWidth * rem2px / defaultFontSize * rate}%`;
          }
      };

      const handleIframeMessage = (event) =>{
        if (event.data && event.data.type === 'autoRotateChange') {
          let wW =  window.innerWidth;
          let wH =  window.innerHeight;
          let frameData = state.frameData;
          let automaticRotation = JSON.parse(localStorage.getItem('automaticRotation'))
          if(event.data.value == 'landscape' && automaticRotation){
            state.screenClass = "inner_box_landscape";
            frameData.width = `${wW - (430 / 1040 * wW)}px`;
            frameData.height = `${518 / 1040 * wW - (220 / 518 * (518 / 1040 * wW))}px`;
            frameData.paddingTop = `${24 / 1040 * wW}px`;
            frameData.paddingBottom = `${24 / 1040 * wW}px`;
            frameData.paddingLeft = `${33 / 518 * (518 / 1040 * wW)}px`;
            frameData.paddingRight = `${33 / 518 * (518 / 1040 * wW)}px`;
            frameData.height ='99%'
            frameData.width = '99.8%'
            // frameData.transform='scale(1.75)';
            state.screen = false
          }
          if(event.data.value == 'portrait'){
            state.screenClass = "inner_box";
            frameData.width = `${518 / 1040 * wH - (66 / 518 * (518 / 1040 * wH))}px`;
            frameData.height = `${wH - (149 / 1040 * wH)}px`;
            frameData.paddingTop = `${120 / 1040 * wH}px`;
            frameData.paddingBottom = `${24 / 1040 * wH}px`;
            frameData.paddingLeft = `${33 / 518 * (518 / 1040 * wH)}px`;
            frameData.paddingRight = `${33 / 518 * (518 / 1040 * wH)}px`;
            if(state.mcGameShow){
              frameData.paddingTop = 0
              frameData.transform='none';
              frameData.height ='99%'
            }
            frameData.transform='none';
            state.screen = true

          }
        }
      };
      const beforeReload = async (e)=>{
        if(state.Util.testEnv()){
          localStorage.removeItem('automaticRotation')
        }
      }

      //自动登陆
      const autoLogin = async (token,username) => {
          console.log("autoLogin")
          try {
              await state.Util.delCookieLocalStorage('access_token');
              const { business_type, platform, game_id } = state.Util.getStatInfo();
              const data = {
                  access_token: token,
                  login_save:1,
                  business_type,
                  platform,
                  // channel: report.channel || "",
                  // device_id: report.device_id || "",
                  game_id,
                  is_h5: 1,
              }

              let apiUrl = '';
              switch(window.Config.platform){
                  case 'mengw':
                  case 'chuangyue':
                      apiUrl = '/user/login';
                      break;
                  case 'm9377':
                      apiUrl = '/user/token_login';
                      data.username = username;
                      break;
                  default:
                      apiUrl = '/user/token_login';
                      data.username = username;
                      break;
              }
              const res = await state.Util.getUserJson(apiUrl, "POST", data, false);
              // alert(JSON.stringify(res))
              console.log("res:", res)
              if(res.code == '1' || res.code == 1){
                  state.Util.setCookieLocalStorage("access_token", res.data.jwt_token || res.data.access_token);
                  // 先保存登录信息
                  await setUserInfo(res);

                  // 根据当前路径决定下一步操作
                  const currentPath = router.currentRoute.value.path;
                  const redirecturl = state.Util.getUrlParam('redirecturl');

                  // 如果当前已经在SDK页面，不需要再跳转
                  if (currentPath.indexOf('/sdk') > -1) {
                      console.log('已经在SDK页面，不再跳转');
                      // 可能需要刷新当前页面数据
                      return;
                  }

                  // 如果有redirecturl参数，优先处理
                  if (redirecturl) {
                      window.location.href = redirecturl;
                      return;
                  }

                  // 正常获取用户信息和处理可能的跳转
                  await getUserInfo();
              }else{
                //   window.Components.toast(res.msg);
              }
          }catch(error){
              console.log('autoLogin错误:', error);
          }
      };

      const judgePage = () => {
          switch (state.Util.getUrlParam('view')){
              case "gift":
                  router.push({name: 'welfare', query: {active: 'gift', hideHeader: true}})
                  break;
              default :
                  break;
          }
      };


      const setUserInfo = async (res) => {
              state.Util.setCookie("access_token", res.data.jwt_token || res.data.access_token);

              let result = await state.Util.refreshUserInfo();
              if(result.code !== 1){
                  state.Util.login()
              }else{
                  let arr = {
                      user: result.data.username,
                      pwd: /* state.password ? state.password :  */'',
                      nickName: result.data.nickname || result.data.username,
                      t: res.data.jwt_token || res.data.access_token,
                      vip: result.data.vip,
                      sex: result.data.sex,
                      en: 0
                  }
                  await state.Util.setUserListLocalStorage('userList', {...arr});
                  await state.Util.setUserListLocalStorage('userLogin', {...arr});
                  store.commit('setUserInfo',result.data)
                  const currentPath = router.currentRoute.value.path;
                  console.log('currentPath:', currentPath);



                  const routerurl = state.Util.getUrlParam("routerurl");
                  const redirecturl = state.Util.getUrlParam("redirecturl");
                  if (currentPath.indexOf('/sdk') > -1/* && !(routerurl || redirecturl)*/) {
                    console.log('当前是SDK页面，不进行路由干预');
                    // return;
                  }else {
                    state.Util.judgeJumpUrl();
                  }
              }
          }

      const getUserInfo = async () => {
          let res = await state.Util.refreshUserInfo();
          // let vip = await state.Util.requestVipAssets();
          // let icons = await state.Util.requestDefaultIcons();
          if (window.reloadSdkPage) {
              console.log("window.reloadSdkPage:", window.reloadSdkPage)
              const targetPath = window.reloadSdkPage;
              // 清除保存的页面，防止循环重定向
              window.reloadSdkPage = null;
              router.replace({
                  path: targetPath,
              });
              return true; // 返回true表示已处理跳转
          }
          if(router.currentRoute.value.path === '/'){
              return false;
          }
          else if(res.code === undefined){
              return false;
          }
          else if(res.code !== 1){
              state.Util.login();
          };
      };

      const getWXData = async() => {
          const res = await state.Util.getJson('/common/wxInfo', 'GET', {referer_url: window.location.href}, true);
          if(res.code == 1){
              wx.config({
                  debug: false,
                  appId: res.data.sign_package.appId,
                  timestamp: res.data.sign_package.timestamp,
                  nonceStr: res.data.sign_package.nonceStr,
                  signature: res.data.sign_package.signature,
                  jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"]
              });

              // 要分享的内容
              var wxData = {
                  title: "9377大师",
                  link: window.location.href, // 分享链接
                  imgUrl: window.location.origin + logo,
                  desc: ""
              };

              wx.ready(function() {
                  //需在用户可能点击分享按钮前就先调用
                  wx.onMenuShareTimeline({
                      //分享朋友圈
                      title: wxData.desc, // 分享标题
                      link: wxData.link, // 分享链接
                      imgUrl: wxData.imgUrl, // 分享图标
                      complete: function() {
                          window.Components.toast("分享朋友圈成功！");
                      }
                  });

                  wx.onMenuShareAppMessage({
                      //分享好友
                      title: wxData.desc, // 分享标题
                      link: wxData.link, // 分享链接
                      imgUrl: wxData.imgUrl, // 分享图标
                      complete: function() {
                          window.Components.toast("分享好友成功！");
                      }
                  });
              });
          }
      }

      const judgeUpdate = async () => {
          let params = {
              channel: state.Util.getUrlParam("channel")
          }
          let version = state.Util.getUrlParam("versionCode")

          if(version != ""){
              const res = await state.Util.getJson('/common/channel',"GET", params, true);
              if(res.code == 1 && res.data.version != "" && res.data.version != undefined && res.data.version != version){
                  Dialog.confirm({
                      message: `发现最新版本${res.data.version}，请下载最新包安装后继续使用。`,
                      confirmButtonText: '下载最新包',
                      showCancelButton: false,
                      beforeClose:(action, done) =>{
                          try{
                              DownloadGame.getGameUrl(res.data.download_url);
                          }catch(err){
                              console.log("包错误");
                          }
                      }
                  })
              };
          }
      };

      // 前端检查更新(强更旧包)
      const frontendCheckUpdate = async () => {
        const platform = window.Config.platform;
        const channel = state.Util.getUrlParam("channel");
        const version = state.Util.getUrlParam("versionCode")?.replace(/^[vV]/, '');
        const gameid = state.Util.getUrlParam("gameid");
        if(version && platform == 'mengw'){
            const forceVersion = '2.0.6'; // 低于此版本会强制更新

            // 比较版本号，只有当前版本低于forceVersion时才会弹窗
            const compareVersion = (v1, v2) => {
              const v1Parts = v1.split('.').map(Number);
              const v2Parts = v2.split('.').map(Number);

              for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
                const part1 = v1Parts[i] || 0;
                const part2 = v2Parts[i] || 0;

                if (part1 < part2) return -1; // v1 < v2
                if (part1 > part2) return 1;  // v1 > v2
              }

              return 0; // v1 == v2
            };

            // 只有当版本比较结果小于0（即当前版本低于forceVersion）时才执行更新逻辑
            if (compareVersion(version, forceVersion) < 0) {
              try{
                  const res = await state.Util.getJson2("/info/v1/gamehub_version", "GET", {
                  }, false);
                  if(res.code == 0) {
                      const onlineVersion = res.data.version?.replace(/^[vV]/, '');
                      const downloadUrl = res.data.url;
                      const appIcon = res.data.icon;
                      try{
                          Dialog.confirm({
                              message: `有新版本${onlineVersion}可更新，请点击下方按钮下载`,
                              confirmButtonText: '立即更新',
                              showCancelButton: true,
                              cancelButtonText: '复制链接',
                              beforeClose: (action) => {
                                  return new Promise((resolve) => {
                                      if (action === 'confirm') {
                                          try {
                                              state.Util.clickStat('weal_click_download_box', {down_url: downloadUrl});
                                              try {
                                                state.Util.goLink(downloadUrl);
                                              } catch(err) {
                                                console.log("发送错误:", err);
                                                // 旧包方法
                                                AndroidUtils.jumpBrowser(downloadUrl);
                                              }
                                              resolve(false);
                                          } catch(err) {
                                              console.log("发送错误:", err);
                                          }
                                          resolve(false);
                                      } else if (action === 'cancel') {
                                          try {
                                              if (state.Util.copyText(downloadUrl)) {
                                                  window.Components.toast('复制成功');
                                              } else {
                                                  window.Components.toast('复制失败');
                                              }
                                              resolve(false);
                                          } catch(err) {
                                              console.log("复制错误:", err);
                                          }
                                          resolve(false);
                                      } else {
                                        resolve(false);
                                      }
                                      resolve(false);
                                  });
                              }
                          })
                      }catch(e){
                          console.log(e)
                      }
                  }else {
                      if(res.message !== '') {
                          window.Components.toast(res.message)
                      }
                  }
              }catch(e){
                  console.log(e)
              }
            }
        }
      }


      onBeforeMount(async () => {
          console.log("onBeforeMount")
          console.log("url:", window.location.href)
          // alert("url:", window.location.href.toString())

          /* S pc微端的时候 判断 改样式*/
          try {
              const str = window.external && window.external.getClientProName && window.external.getClientProName();
              console.log("str:", str);
              if (str == "McGame") {
                  state.mcGameShow = true;
              }
          } catch (e) {
              console.log("获取PC微端信息错误:", e);
          }
          /* E pc微端的时候 判断 改样式*/

          state.href = window.document.location.href; //如果是pc端的话，要用iframe套一层,做手机框
          console.log("state.Util.testEnv():", state.Util.testEnv());
          console.log("state.isFrame:", state.isFrame);

          // if(state.Util.testEnv() && state.isFrame){
              // alert("state.Util.testEnv() :", state.Util.testEnv() );
              // alert("state.isFrame :", state.isFrame );
              // const res = await state.Util.getJson('/common/background',"GET", {}, true);
              // if(res.code == 1){ state.bgImg = res.data; };
          // }else {

              // judgePage();

          //自动登陆功能，如果有传过来access_token和username，就走换token功能
          try {
              const access_token = state.Util.getUrlParam('access_token');
              console.log("access_token:", access_token);
              const username = state.Util.getUrlParam('username');
              if(access_token != null && username != null) {
                state.Util.sendUserLoginInfo(access_token, username)
              }
              console.log("username:", username);
              const redirecturl = state.Util.getUrlParam('redirecturl');
              console.log("redirecturl:", redirecturl);
              const currentPath = router.currentRoute.value.path;
              console.log("currentPath:", currentPath);
              const local_access_token = state.Util.Cookie().get("access_token");
              console.log("local_access_token:", local_access_token);

              // 处理SDK路径
              if (currentPath.indexOf('/sdk') > -1) {
                  console.log("检测到SDK页面路径");
                  // SDK页面且有access_token，执行登录
                  if (access_token) {
                      await autoLogin(access_token, username).catch(e => {
                          console.log("自动登录错误:", e);
                      });
                      return; // 登录后直接返回，避免后续逻辑
                  }
              }

              // 常规登录处理流程
              if (access_token/* && local_access_token !== access_token*/) {
                  await autoLogin(access_token, username).catch(e => {
                      console.log("自动登录错误:", e);
                  });
              } else if (redirecturl) {
                  // 重定向处理
                  console.log("处理重定向到:", redirecturl);
                  if (local_access_token) {
                      // 有本地token，直接跳转到重定向URL并附加token
                      const tokenParam = redirecturl.includes('?') ? '&' : '?';
                      window.location.href = `${redirecturl}${tokenParam}access_token=${local_access_token}`;
                  } else {
                      // 没有token，先登录
                      state.Util.login();
                  }
              } else {
                  await getUserInfo().catch(e => {
                      console.log("获取用户信息错误:", e);
                  });
              }
          } catch (e) {
              console.log("登录流程错误:", e);
          }
          // }

          // 客户端应用初始化
          try {
              let isAppClient = false;
              try {
                  isAppClient = state.Util.isAPPClient();
              } catch (error) {
                  console.error('检查 APP 客户端状态失败:', error);
                  isAppClient = false;
              }

              if (isAppClient) {
                  await setClientInfo().catch(e => {
                      console.log("setClientInfo错误:", e);
                  });
              }
          } catch (e) {
              console.log("客户端初始化错误:", e);
          }
      });

      onMounted(async() => {
          // 设置文档标题为平台对应的应用名称
          document.title = window.Config.appName || '9377大师';

          window.addEventListener('message', handleIframeMessage);
          window.addEventListener('beforeunload', (e) => beforeReload(e))
          state.Util.setLocalStatInfo();
          state.Util.statsLogin(); //登录行为上报
          initRemSize();
          frontendCheckUpdate();
      });

      // S 壳包调用的方法
      const Package = {
          openLogin: () => { //账号登录
              state.Util.login({query: {type: 'user'}});
          },
          openRegister: () => { //快速注册
              router.push({name: 'register'})
          },
          openPhone: () => {//其他手机
              state.Util.login();
          },
          openCustomer: () => {//客服
              state.Util.complaint();
          },
          openAgreement: (target) => {
              if(target == 1){//用户协议
                  router.push({name: '/agreement', params: {type: 'user'}})
              }else if(target == 2){//隐私协议
                  router.push({name: '/agreement', params: {type: 'privacy'}})
              }
          },
          PhoneLoginSuccess: async (token) => {// 一键登录成功
              try {
                  let report = JSON.parse(sessionStorage.getItem('report'));
                  let data = {
                      channel_token: token,
                      third_party_channel: "shanyan",
                      type: report.type || "1",
                      channel: report.channel || "",
                      device_id: report.device_id || "",
                      // gameid: report.gameid || "",
                      gameid: "",
                      is_h5: 1,
                  }
                  const res = await state.Util.getJson('/user/quickLogin',"POST", data, true);

                  if(res.code == 1){
                      state.Util.setCookie("access_token", res.data.access_token);
                      getUserInfo();
                      regRealname();
                  }
              } catch (error) {
                  console.info(error);
              }

          },
          PhoneLoginError: () => {// 一键登录失败
              state.Util.login();
          },
          PhoneLoginClosed: () => {},
          openClostDialog: () => { //手机返回键 -- 退出
              let mainPage = ['/', '/game', '/welfare', '/index', '/mine'];
              window.Components.toast.clear();

              if(mainPage.indexOf(router.currentRoute.value.path) > -1){
                  let nowTime = new Date().getTime();
                  if(nowTime - state.closeAppTime <= 2000){
                      state.Util.closeApp();
                  }else{
                      state.closeAppTime = nowTime;
                      window.Components.toast('再按一次退出软件');
                  }
              }else{
                  router.back();
              }
          },
      };
      // E 壳包调用的方法

      // S 壳包/SDK里获取手机的属性
        const setClientInfo = async () => {
            try {
                const res = await Promise.all([
                    state.Util.getSysInfo(),
                    state.Util.getAppOrientation(),
                    state.Util.getAppClient(),
                ]);

                console.log("res:", res)

                const info = res[0]

                try {
                    window.sdkBridge[100] = () => {
                        Package.openClostDialog()
                    };
                } catch (err) {
                    console.log("设置sdkBridge错误:", err);
                }

                try {
                    window.sdkBridge[39] = (data) => {
                      console.log("data:", data)
                      try {
                          const { rq_environment = '' } = data.data;
                          if(rq_environment === "cs_sdk"){
                              window.Config.isSdk = true;
                          }
                      } catch (err) {
                          console.log("发送错误:", err);
                      }
                    };
                } catch (err) {
                    console.log("设置sdkBridge错误:", err);
                }

                state.isForbidding = true;

                try {
                    const obj = {
                        mac: info.mac || '',
                        androidid: info.android_id || '',
                        device_id: info.device_id || '',
                        device_oaid: info.device_oaid || '',
                        device_imei: info.device_imei || '',
                        device_os: info.device_os || '',
                        is_emulator: info.is_emulator || 0,
                    }
                    sessionStorage.setItem('sysInfo', JSON.stringify(obj));
                } catch (err) {
                    console.log("保存系统信息错误:", err);
                }
            } catch (err) {
                console.log("获取客户端信息错误:", err);
            }
        };
      // E 壳包里获取手机的属性

      // S 验证壳包里的一键登录是否已实名
      const regRealname = async () => {
          let res = await state.Util.refreshUserInfo();

          if(res.code == 1){
              let arr = {
                  user: res.data.username,
                  pwd: '',
                  nickName: res.data.nickname,
                  t: res.data.jwt_token || res.data.access_token,
                  vip: res.data.vip,
                  sex: res.data.sex,
                  en: 0
              }
              state.Util.setUserListLocalStorage('userList', arr);

              if(res.data.is_real_name != 0){ //表示已实名
                  if(window.Config.rebackUrl){
                      if(window.Config.rebackUrl != 'nolink'){ //nolink 是一个约定值，表示不做任何跳转,就登录
                          router.push({name: window.Config.rebackUrl});
                      }
                  }else {
                      router.replace({name: 'index'});
                  }
                  //使用完毕清空上一次的情况
                  window.Config.rebackUrl = '';
              }else {
                  window.Config.realnameLock = true;
                  Dialog.alert({
                      message: '当前账号未实名，根据国家规定，请先实名',
                  }).then(() => {
                      // router.push({name: 'realname'})
                      const local_access_token = state.Util.Cookie().get("access_token");
                      // 跳转登录微服务
                      const query = {};
                      state.Util.goToRealname(query);
                  });
              }
          }
      };
      // E 验证壳包里的一键登录是否已实名

      const methods = {
          triggerRotation: ()=>{
              state.screen = !state.screen;
              initRemSize();
          },
      }

      return {
          methods,
          ...toRefs(state)
      }
    },
  });
  </script>

  <style lang="less" scoped>
  @import "./assets/less/common/app.less";
  </style>
